import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6 3.002a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-12a3 3 0 0 0-3-3zm1.5 1.5a.75.75 0 0 0-.75.75v11.25a.75.75 0 0 0 1.085.671L12 15.091l4.165 2.082a.75.75 0 0 0 1.085-.67V5.252a.75.75 0 0 0-.75-.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }